import { useEffect, useMemo, useState } from 'react';
import { ReferralsApiRepository } from './ReferralsApiRepository';

export const useGenerateReferralId = () => {
  const repository = useMemo(() => new ReferralsApiRepository(), []);
  const [referralId, setReferralId] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    let active = true;

    repository
      .generateId()
      .then((generatedId) => {
        if (active) {
          setReferralId(generatedId);
        }
      })
      .catch((error: unknown) => {
        console.error(error);
        if (active) {
          setErrorMessage(
            error instanceof Error
              ? error.message
              : 'Failed to generate a referral ID',
          );
        }
      });

    return () => {
      active = false;
    };
  }, [repository]);

  return { referralId, errorMessage };
};
